<template>
  <span class="flex items-center justify-center overflow-visible">
    <img
      :src="src"
      alt=""
      class="rounded-[2px]"
      :class="
        fit === 'height'
          ? 'h-[17px] w-auto max-w-none shrink-0 tablet-h:h-[14px]'
          : 'h-auto w-full'
      "
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import BasicMembership from '@/assets/images/BasicMembership.png'
import MembershipCard from '@/assets/images/MembershipCard.png'
import { useBillingStore } from '@/features/billing/store'

const props = withDefaults(
  defineProps<{
    fit?: 'height' | 'width'
    variant?: 'basic' | 'pro'
  }>(),
  { fit: 'height' }
)

const billingStore = useBillingStore()
const resolvedVariant = computed(
  () => props.variant ?? (billingStore.isBasicMembership ? 'basic' : 'pro')
)
const src = computed(() =>
  resolvedVariant.value === 'basic' ? BasicMembership : MembershipCard
)
</script>
